module.exports = __webpack_public_path__ + "52ec4237595d046fe105ffe5fcd726fe.pdf";